import Vue from 'vue'
import Router from 'vue-router'
import routerLists from './routerLists';

Vue.use(Router)
/** 避免重复点击报错 */
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'history',
  routes: [...routerLists, {
    path: '/vote',
    label: '金翎奖投票',
    key: 'vote',
    component: () => import('@/components/pages/vote')
  },
  {
    path: '/privacy',
    label: '隐私政策',
    key: 'privacy',
    component: () => import('@/components/pages/privacy/privacyNew')
  },
  // {
  //   path: '/privacy-funjoy',
  //   label: '隐私政策',
  //   key: 'privacy',
  //   component: () => import('@/components/pages/privacy/privacy-funjoy')
  // },
  // {
  //   path: '/privacy-autumn',
  //   label: '隐私政策',
  //   key: 'privacy',
  //   component: () => import('@/components/pages/privacy/privacy-autumn')
  // },
  {
    path: '/terms',
    label: '用户协议',
    key: 'terms',
    component: () => import('@/components/pages/privacy/termsNew')
  },
  // {
  //   path: '/terms-funjoy',
  //   label: '用户协议',
  //   key: 'terms',
  //   component: () => import('@/components/pages/privacy/terms-funjoy')
  // },
  // {
  //   path: '/terms-autumn',
  //   label: '用户协议',
  //   key: 'terms',
  //   component: () => import('@/components/pages/privacy/terms-autumn')
  // },
  {
    path: '/privacy/agreementId=E20200101',
    label: '隐私政策',
    key: 'privacy',
    component: () => import('@/components/pages/privacy/privacy')
  },
  {
    path: '/terms/agreementId=E20200101',
    label: '用户协议',
    key: 'terms',
    component: () => import('@/components/pages/privacy/terms')
  }, {
    path: '/thirdlist',
    label: '第三方服务共享清单',
    key: 'thirdlist',
    component: () => import('@/components/pages/privacy/thirdlist')
  },{
    path: '/deleteAccount/:appId',
    label: 'Delete Account',
    key: 'deleteAccount',
    component: () => import('@/components/pages/deleteAccount/index.vue')
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js